import { createRootRouteWithContext } from "@tanstack/react-router";
import {
    appShellRootRouteOptions,
    type AppShellRouteContext,
} from "@/app-clients/app-shell";

export const Route = createRootRouteWithContext<AppShellRouteContext>()(
    appShellRootRouteOptions,
);
